/**
 * 前端存储
 * @param name
 * @param value
 */
export const setStorage = (name: string, value: any) => {
  window.localStorage.setItem(name, value)
}

/**
 * 获取存储
 * @param name
 * @returns
 */
export const getStorage = (name: string) => {
  return window.localStorage.getItem(name) || null
}

/**
 * 删除存储
 * @param name
 */
export const deleteStorage = (name: string) => {
  window.localStorage.removeItem(name)
}

/**
 * 获取微信授权地址
 * @param appId
 */
export const getAuthUrl = (appId: string, redirectUrl: string, scope: string = 'snsapi_base') => {
  return `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appId}&redirect_uri=${redirectUrl}&response_type=code&scope=${scope}&state=STATE#wechat_redirect`
}

/**
 * 获取地址栏参数
 * @param key
 */
export const getURLSearchParams = (key: string): string | null => {
  const params = new URLSearchParams(window.location.search)
  return params.get(key) || null
}